import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import { selectCognitoUserObject } from 'utils/cognito.util';
import isFn from 'utils/predicates/function/isFn.util';

const selectCognitoUserNameExhaustively = (state) => {
  const user = selectCognitoUserObject(state);

  if (isFn(user.getUsername)) return user.getUsername();

  if (getAnyOrVoid('cognito.userName', state)) {
    return getAnyOrVoid('cognito.cache.userName', state);
  }

  return '';
};

// noinspection JSUnusedGlobalSymbols
export default selectCognitoUserNameExhaustively;
